var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25658_568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.53367 1.54487L0.739591 8.93258C0.640748 9.09058 0.588449 9.26972 0.587895 9.45218C0.587342 9.63464 0.638554 9.81405 0.736437 9.97256C0.834319 10.1311 0.975461 10.2632 1.14582 10.3557C1.31618 10.4482 1.50981 10.498 1.70746 10.5H11.2956C11.4933 10.498 11.6869 10.4482 11.8573 10.3557C12.0276 10.2632 12.1688 10.1311 12.2667 9.97256C12.3645 9.81405 12.4157 9.63464 12.4152 9.45218C12.4146 9.26972 12.3623 9.09058 12.2635 8.93258L7.46942 1.54487C7.36852 1.39132 7.22644 1.26437 7.05691 1.17626C6.88738 1.08816 6.6961 1.04187 6.50154 1.04187C6.30699 1.04187 6.11572 1.08816 5.94618 1.17626C5.77665 1.26437 5.63458 1.39132 5.53367 1.54487Z",
    fill: "#6E6E84",
    stroke: "#6E6E84",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 3.72397V6.2645M6.5 8.87232V8.97327",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25658_568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangleIcon);
export default __webpack_public_path__ + "static/media/error-triangle-icon.58098d84.svg";
export { ForwardRef as ReactComponent };